(function () {
  'use strict';

  if (window.__namyCustomerAddressesInit) return;
  window.__namyCustomerAddressesInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    /* Toggle new address form */
    var newForm = document.getElementById('mg-new-address-form');
    document.querySelectorAll('[data-toggle-new-address]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (newForm) newForm.hidden = !newForm.hidden;
      });
    });

    /* Toggle edit address forms */
    document.querySelectorAll('[data-toggle-edit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-toggle-edit');
        var editForm = document.getElementById('mg-edit-address-' + id);
        if (editForm) editForm.hidden = !editForm.hidden;
      });
    });

    /* Confirm delete via data attribute */
    document.querySelectorAll('[data-confirm-message]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var message = btn.getAttribute('data-confirm-message');
        if (!confirm(message)) {
          e.preventDefault();
        }
      });
    });

    /* Country/province selector - Shopify provides this globally */
    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      /* New address form */
      new Shopify.CountryProvinceSelector('mg-new-country', 'mg-new-province', { hideElement: 'mg-new-province-wrap' });

      /* Edit address forms — one per existing address */
      document.querySelectorAll('[data-edit-address-id]').forEach(function (el) {
        var addrId = el.getAttribute('data-edit-address-id');
        new Shopify.CountryProvinceSelector(
          'mg-edit-country-' + addrId,
          'mg-edit-province-' + addrId,
          { hideElement: 'mg-edit-province-wrap-' + addrId }
        );
      });
    }
  });
})();
